<template>
  <div class="pa-2">
    <section class="boarding-hierarchy-card">
      <div class="pa-4">
        <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
          <div class="d-flex">
            <div class="mr-4">
              <span class="font-weight-bold"> Embarque: </span>
              <span class="font-weight-regular"> {{ boarding.boardingNumber || boarding.BoardingNumber }} </span>
            </div>
            <div class="mr-4">
              <span class="font-weight-bold">Motorista: </span>
              <TruncateDataWithTooltip
                :data="boarding.directDelivererName || boarding.DirectDelivererName"
                :lengthDataToTruncate="truncateLimit"
              ></TruncateDataWithTooltip>
            </div>
            <div class="mr-4">
              <span class="font-weight-bold">Quilometragem total: </span>
              <span class="font-weight-regular">{{ boarding.totalMileage || boarding.TotalMileage }}</span>
            </div>
            <div class="mr-4">
              <span class="font-weight-bold">Frete motorista: </span>
              <span class="font-weight-regular">{{ formatPrice(boarding.freightPrice || boarding.FreightPrice) }}</span>
            </div>
          </div>
          <div class="d-flex">
            <v-icon @click="toggleCollapsed">
              {{ isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
            </v-icon>
          </div>
        </v-card-text>
        <v-card-text class="d-flex pa-0">
          <div>
            <span class="font-weight-bold text--secondary">Frete total dos transbordos: </span>
            <span class="font-weight-regular mr-4">{{
              formatPrice(boarding.totalTranshipmentsPrice || boarding.TotalTranshipmentsPrice || 0)
            }}</span>
          </div>
          <div>
            <span class="font-weight-bold text--secondary">Frete total dos embarcadores: </span>
            <span class="font-weight-regular mr-4">{{
              formatPrice(boarding.totalDeliveriesPrice || boarding.TotalDeliveriesPrice)
            }}</span>
          </div>
          <div>
            <span class="font-weight-bold text--secondary">Valor total das mercadorias: </span>
            <span class="font-weight-regular mr-4">{{
              formatPrice(boarding.totalNfesPrice || boarding.TotalNfesPrice)
            }}</span>
          </div>
          <div>
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular mr-4"
              >{{ formatWeight(boarding.weightCargos || boarding.WeightCargos || 0) }}kg</span
            >
          </div>
          <div>
            <span class="font-weight-bold text--secondary">Quantidade de cargas: </span>
            <span class="font-weight-regular"> {{ boarding.amountCargos || boarding.AmountCargos }} </span>
          </div>
        </v-card-text>
      </div>
      <div v-if="!isCollapsed">
        <CargoHierarchyCard
          v-for="item in alocatedCargos"
          :importedSuccessfully="importedSuccessfully"
          :key="item.id"
          :cargo="item"
        />
      </div>
      <v-progress-linear v-if="isLoadingAlocated" indeterminate color="primary" class="mr-2"></v-progress-linear>
    </section>
  </div>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import CargoHierarchyCard from '@/components/ManualBoardingImport/Stepper/Step7/HierarchyDetails/CargoHierarchyDetails.vue';
import maskPrice from '@/utils/maskPrice';
import copyToClipboard from '@/utils/copyToClipboard';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';

export default {
  components: {
    TruncateDataWithTooltip,
    CargoHierarchyCard
  },
  props: {
    boarding: {
      default: () => ({}),
      type: Object
    },
    importedSuccessfully: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isCollapsed: true,
    alocatedCargos: []
  }),
  computed: {
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    }
  },
  methods: {
    ...mapActions('ImportManualBoardingsStore', ['getCargosByBoardingId', 'editBoarding', 'allocateCargo']),
    async toggleCollapsed() {
      if (!this.isCollapsed) {
        this.isCollapsed = true;
      } else {
        this.isLoadingAlocated = true;
        try {
          if (this.importedSuccessfully) {
            this.alocatedCargos = this.boarding.CargosTemp;
          } else {
            const data = await this.getCargosByBoardingId(this.boarding.id);
            this.alocatedCargos = data;
          }
          this.isCollapsed = false;
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoadingAlocated = false;
        }
      }
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    }
  }
};
</script>

<style scoped>
.boarding-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
</style>
